import { gql } from '@apollo/client';

const ReferralInfoPublic = gql`
  fragment ReferralInfoPublic on Referral {
    id
    state
    consumedAt
    customerOptions
    accountId
    source
    hexCode
    isFreeTrial
    subscriptionDisclosure {
      required
      requiresPaymentMethod
      items {
        key
        source
        orderItemId
        patient {
          id
          firstName
          lastName
        }
        product {
          id
          name
          productType
          planStartInterval
          planSubscription {
            id
            name
            price
            renewalIntervalMonths
          }
        }
      }
      tiers {
        price
        overPrice
        units
        product {
          id
          name
          description
          price
          productType
          renewalIntervalMonths
        }
      }
    }
    account {
      id
      accountAddresses {
        id
        address
        address2
        city
        region
        postalCode
        country
        isBilling
        isShipping
        isDefault
      }
    }
    cart {
      id
      cartItemsAttributes {
        id
        name
        price
        discountAmount
        taxAmount
        shippingAmount
        total
        quantity
        productId
        product {
          id
          featuredImage
          description
        }
      }
    }
    partnerOrganization {
      id
      name
      imageUrl
      address {
        id
        city
        region
        country
      }
    }
    partnerLocation {
      id
      name
      imageUrl
      address {
        id
        city
        region
        country
      }
    }
    userAttributes {
      id
      firstName
      lastName
      email
      phone
      state
      acceptTerms
      acceptSms
      acceptMarketing
    }
    patientAttributes {
      id
      firstName
      lastName
      arches
      dob
      birthDay
      birthMonth
      birthYear
      includeEot
    }
    createdAt
    updatedAt
  }
`;

export default ReferralInfoPublic;
